export enum StatusLabel {
  Hold = 'HOLD',
  Closed = 'CLOSED',
  Received = 'RECEIVED',
  Below = 'BELOW',
  Avg = 'AVERAGE',
  Superb = 'SUPERB',
  ForceClose = 'FORCE_CLOSE',
  AutoStart = 'AUTO_START',
  NoAnswer = 'NO_ANSWER',
  Reminder = 'REMINDER',
  ReminderWithCancellation = 'REMINDER_WITH_CANCELLATION',
  FleetIntegrationCanceled = 'FLEET_INTEGRATION_CANCELED',
  MadarReminder = 'MADAR_REMINDER',
}
